import React, { useState } from "react";
import MideaViewer from "../../../../../midea_viewer/MideaViewer";
import { iconData } from "../../../../../iconData";
import { Player } from "video-react";
import { IP } from "./../../../../../internalServer";

// css comes in create_hw_file.css

const AttachUInonEditable = ({ attachments }) => {
  const [mideaviewer, setMideaviewer] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  // let attachments = Array.isArray(attach) ? attach : [attach];

  console.log(attachments, "attachments in attachUI non editable");
  const attachformat = (para) => {
    const filePath = para;
    const fileName = filePath?.split("/").pop();
    const fileNameWithoutId = fileName?.split("_")[1];
    return fileNameWithoutId;
  };
  const handleClick = (attachmentName) => {
    setResponseAttach(attachmentName);
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachments) => {
    setResponseAttach(attachments);
    setMideaviewer(true);
  };
  // function shortenParagraph(text, maxLength) {
  //   if (text.length <= maxLength) {
  //     return text;
  //   }
  //   return text.slice(0, maxLength).trim() + '...';
  // }
  const attachmentName = Array.isArray(attachments)
    ? attachments[0]
    : attachments;

  const getExtension = (file) => file?.split(".").pop()?.toLowerCase();

  const isImage = (ext) => ["jpg", "jpeg", "png"].includes(ext);

  const isVideo = (ext) => ["mp4"].includes(ext);

  const isPdf = (ext) => ext === "pdf";

  const isOfficeFile = (ext) => ["doc", "docx", "xls", "xlsx"].includes(ext);

  console.log(isOfficeFile, "isOfflice file?");

  const openOfficeInViewer = (file) => {
    const fileUrl = encodeURIComponent(IP + file.replace(/^\./, ""));
    window.open(
      `https://docs.google.com/gview?url=${fileUrl}&embedded=true`,
      "_blank",
    );
  };

  return (
    <>
      <div
        className=" hw_defult_attach_box"
        style={{ padding: "0px ", width: "200px" }}
        onClick={() => {
          const ext = getExtension(attachmentName);

          if (isImage(ext) || isVideo(ext)) {
            handleClick(attachmentName);
          } else if (isPdf(ext)) {
            handleClickforpdf(attachmentName);
          } else if (isOfficeFile(ext)) {
            openOfficeInViewer(attachmentName); // 🔥 DOC / XLS handling
          }
        }}
      >
        <>
          {attachmentName?.split(".").pop() === "jpg" ||
          attachmentName?.split(".").pop() === "jpeg" ||
          attachmentName?.split(".").pop() === "JPEG" ||
          attachmentName?.split(".").pop() === "JPG" ||
          attachmentName?.split(".").pop() === "PNG" ||
          attachmentName?.split(".").pop() === "png" ? (
            <div
              onClick={() => {
                if (!isError) {
                  handleClick(attachmentName);
                }
              }}
              className="ContainerUploadedPdf d-flex gap-2 p-1"
            >
              <div className="d-flex align-items-center pdf_logo">
                <img
                  src={`${
                    iconData?.find(
                      (i) => i.extension === attachmentName?.split(".").pop(),
                    )?.icon || ""
                  }`} // Fallback to empty string if icon is not found
                  alt=""
                  className="attachLogoActivity"
                />
              </div>
            </div>
          ) : (
            <div
              className="d-flex align-items-center pdf_logo"
              onClick={() => handleClickforpdf(attachmentName)}
            >
              <img
                className="attachLogoActivity"
                src={`${
                  iconData?.find(
                    (i) =>
                      i.extension === attachmentName?.match(/\.([^.]+)$/)?.[1],
                  )?.icon || ""
                }`} // Fallback to empty string if icon is not found
                alt=""
              />
            </div>
          )}
        </>
        <div className="" style={{ fontSize: "15px" }}>
          <span>{attachformat(attachmentName)}</span>
        </div>
      </div>
      {mideaviewer && (
        <MideaViewer
          closeMideaviewer={setMideaviewer}
          attachment={attachments}
        />
      )}
      {isClicked &&
        (responseAttach?.split(".").pop() === "mp4" ||
        responseAttach?.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  {/* {console.log("1st")} */}
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  {/* {console.log("2nd")} */}
                  <img
                    onClick={() => {
                      handleClick();
                      setIsError(false);
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo-1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
              {/* <img
                className="imgMain"
                src={IP + responseAttach?.replace(/^\./, "")}
                alt="Full-size"
              />
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div> */}
            </div>
          </div>
        ))}
    </>
  );
};

export default AttachUInonEditable;
